module.exports = require("node:dns/promises");